export default __webpack_public_path__ + "static/ready-set-relax-8-ways-you-can-actually-relax-on-holiday-037278be2dd277405d8121cbdd7475fe.jpg";